import filter from 'lodash/filter';

export default {
  gatewayLoaded: state => state.gatewayLoaded,
  isGameActive: state => state.isGameActive,
  betTypes: state => state.betTypes,
  apiLocationConfig: state => state.apiLocationConfig,
  gameConfig: state => state.gameConfig,
  gameId: state => state.gameId,
  keyEventTimestamp: state => state.keyEventTimestamp,
  companyConfig: state => state.companyConfig,
  companyTheme: state => state.companyConfig.theme,
  offer: state => state.offer,
  activeBetType: state => state.activeBetType,
  selected: state => state.selected,
  bets: state => state.bets,
  bet: state => state.bet,
  translations: state => state.translations,
  editBet: state => state.editBet,
  comboStake: state => state.comboStake,
  singleStake: state => state.singleStake,
  potentionalWin: state => state.potentionalWin,
  globalBetStop: state => state.globalBetstop,
  searchedValue: state => state.searchedValue,
  searchInputActive: state => state.searchInputActive,
  getNoLockedBets: state => filter(state.bets, obj => obj.bettingStatus),
  ticketPreview: state => state.ticketPreview,
  ticketPreviewShow: state => state.ticketPreviewShow,
  ticketPreviewList: () => [],
  ticketPreviewBetslip: state => state.ticketPreviewBetslip,
  addingBet: state => state.addingBet,
  rebet: state => state.rebet,
  socketKeepAlive: state => state.socketKeepAlive,
  validateBetsExistInOffer: (state) => {
    let i = 0;
    let isValid = true;
    while (i < state.bets.length) {
      if (!Object.prototype.hasOwnProperty.call(state.offer, state.bets[i].idMatch)
        || !state.bets[i].bettingStatus) {
        isValid = false;
        break;
      }
      i += 1;
    }
    return isValid;
  },
  getIcon: (state) => {
    let icon = '';
    switch (state.gameId) {
      case 'RushFootball2':
      case 'SportradarVirtualFootball':
        icon = 'n-i-soccer';
        break;
      // no default
    }
    return icon;
  },
  getActiveBetsFromBetslip: state => filter(
    state.bets,
    obj => obj.idMatch === state.selected.match.idMatch,
  ),
  betslipBlocked: state => state.betslipBlocked,
};
